<div class="row">
  <div class="col-md-12">
    <div class="card shadow-sm ">
      <div class="card-header with-border"> Photo</div>
      @if (versionedVessel) {
        <div class="card-body ">
          <div class="col-md-8 mt-3 m-auto">
            @if (versionedVessel.data!.spec!.photoIds) {
              <app-material-slideshow
                [fileId]="versionedVessel.data!.spec!.photoIds"
                (rmFileId)="deleteMode($event)"
                [photoName]="versionedVessel.data!.name!.name"
                [role]="role">
              </app-material-slideshow>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div class="row">
  <!-- بخش Upload Photo -->
  <div class="col-12 col-md-6 mb-3">
    @if (versionedVessel) {
      <div class="card mb-3">
        <div class="card-header">
          <h3 class="card-title">Upload Photo</h3>
        </div>
        <div class="card-body" *appHideIfNotInRole="['vessel:update']">
          <div class="row">
            <div class="col-md-10 col-sm-12 mb-2 mb-sm-2">
              <app-material-chunk-file-uploader
                [accept]="'image/*'"
                id="uploader"
                name="uploader"
                [disabled]="disabled"
                [(ngModel)]="doc"
                (ngModelChange)="savePhoto($event)"
                [required]="true">
              </app-material-chunk-file-uploader>
            </div>
            <div class="col-md-2 col-sm-12 mb-sm-2">
              <app-material-pg-button
                (clicked)="onSubmit()"
                class="w-100"
                label="Save">
              </app-material-pg-button>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- بخش Documents -->
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title">Documents</h3>
      </div>
      <div class="card-body" *appHideIfNotInRole="['vessel:update']">
        <div class="row">
          <div class="col-12">
              <app-material-auto-complete
              class="w-100"
              id="type"
              name="type"
              [(ngModel)]="type"
              [placeholder]="'Type'"
              [items]="types"
              [formatter]="typeFormatter">
              </app-material-auto-complete>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <app-material-date-range
              id="IssueDate"
              name="IssueDate"
              [singleDateSelector]="true"
              [(dateRange)]="issueDate"
              [placeholder]="'Issue Date'">
            </app-material-date-range>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <app-material-chunk-file-uploader
              [accept]="'.pdf'"
              name="form"
              [(ngModel)]="doc2"
              (ngModelChange)="uploadForm($event)"
              [required]="true">
            </app-material-chunk-file-uploader>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-md-2 col-12">
            <app-material-pg-button
              (clicked)="onSubmit()"
              class="w-100"
              label="Save">
            </app-material-pg-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- بخش Change Name -->
  <div class="col-12 col-md-6" *appHideIfNotInRole="['vessel:update']">
    <div class="card shadow-sm">
      <div class="card-header">
        <h3 class="card-title">Change Name</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <app-material-date-range
              id="startDate"
              name="startDate"
              tabindex="1"
              [(dateRange)]="endDateForCurrentPeriod"
              [singleDateSelector]="true"
            >
            </app-material-date-range>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <app-material-pg-input
                class="w-100"
                label="New Name"
                type="text"
                name="vesselName"
                id="vesselName"
                [(ngModel)]="newName"
                [required]="true">
            </app-material-pg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <app-material-organisation-selector
              id="flag"
              class="pg-component w-100"
              [(ngModel)]="flag"
              [organisationLanguage]="'en'"
              name="flag"
              [organisations]="flags"
              [placeholder]="'Flag'"
              [required]="true">
            </app-material-organisation-selector>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-md-2 col-12">
            <app-material-pg-button
              (clicked)="changeName()"
              class="w-100"
              label="Save">
            </app-material-pg-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
@if (versionedVessel) {
  <div class="row">
    <!-- History Tab -->
    <div class="col-12 col-md-6 mb-3">
      <div class="card shadow-sm">
        <div class="card-header">
          <h3 class="card-title">History</h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr>
                  <td *appHideIfNotInRole="['vessel:update']"></td>
                  <td>File</td>
                  <td>Date Update</td>
                </tr>
              </thead>
              <tbody>
                @for (document of versionedVessel.data!.documents; track $index) {
                  <tr>
                    <ng-container>
                      <td *appHideIfNotInRole="['vessels-editor']">
                        <app-material-pg-button
                          id="delete"
                          label="delete"
                          class="btn btn-link"
                          (clicked)="removeDocument(document.documentId)">
                          <i class="fa fa-trash-o"></i>
                        </app-material-pg-button>
                      </td>
                      <td>
                        <a
                          (click)="downloadformId(document.documentId, document.documentType)">
                          <i class="btn btn-link">{{document.documentType}}</i>
                        </a>
                      </td>
                      <td>{{document.issueDate | date}}</td>
                    </ng-container>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Latest Name Tab -->
    <div class="col-12 col-md-6">
      <div class="card shadow-sm">
        <div class="card-header">
          <h3 class="card-title">Latest Name</h3>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered">
              <thead>
                <tr>
                  <td>Name</td>
                  <td>From</td>
                  <td>Flag</td>
                </tr>
              </thead>
              <tbody>
                @for (pre of versionedVessel.data!.previousNames; track $index) {
                  <tr>
                    <ng-container>
                      <td>{{pre.name}}</td>
                      <td>{{pre.from | date}}</td>
                      <td>{{pre.flag}}</td>
                    </ng-container>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
}